import  { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import { showToast } from "../../../components/toast";
import { I_Profile } from "../../inventory/types";
import { RingLoader } from "react-spinners";
import { Plus,  } from "lucide-react";
import Button from "../../../components/button";


interface TransactionDetails {
    _id: string
    amount: number;
    status: string;
}


const TransactionsDetails = () => {
    const { id } = useParams<{ id: string }>();

    const navigate = useNavigate();
    const [profile, setProfile] = useState<I_Profile | null>(null);
    const [transaction, setTransaction] = useState<TransactionDetails | null>(null);


    const userToken = localStorage.getItem("token");
    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getTransactionById } = useRequest(
    `/payment/${id}`,
    "GET"
    );


    useEffect(() => {
    const fetchData = async () => {
      const [response] = await getTransactionById();
      console.log(response);
    };
    fetchData();
  }, []);


    useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
           <Navbar profile={profile as I_Profile} />

           <main className="flex-1 container mx-auto py-6">
            <div className="flex justify-between mt-5">
                <div className="flex gap-4">
                    <div
                    onClick={() => navigate(-1)}
                    className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer"
                    >
                    <Icon name="appbackIcon" className="mt-1" /> Back to Transactions
                    </div>

                    <h1 className="md:text-[30px] -mt-2 font-bold">
                    {/* {requisition?.regionName?.regionName} */}
                    </h1>
                </div>

                <div className="text-[14px] flex gap-2">
                    {transaction?.status !== "pending" && (
                        <>
                        <button
                            type="button"
                            className=" md:mt-0 mt-6 w-full font-normal  border border-[#047401]  rounded-full px-10"
                            // onClick={openSupplierModal}
                        >
                            POS
                        </button>
                        {/* <button
                            type="button"
                            className=" md:mt-0 mt-6 w-full font-normal  border border-[#047401]  rounded-full px-10"
                            // onClick={openSupplierModal}
                        >
                            Resend Payment Link
                        </button> */}
                        <Button
                            size="lg"
                            variant="primary"
                            type="button"
                            className="font-normal md:mt-0 mt-6"
                            // onClick={openSupplierModal}
                        >
                           Mark as Paid
                        </Button>
                        </>
                    )
                        
                    }

                </div>
                
            </div>

           </main>
        </div>
     );
}
 
export default TransactionsDetails;